import React from 'react'
import { Space, Switch } from 'antd'
import { useParams } from 'react-router'
import { useUpdateAssignmentSettingsMutation } from '../../../../../../store/apis/assignment.api'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../../../store/selectors/assignment.selectors'
import { BulbOutlined } from '@ant-design/icons'

const ShowTipsSwitch = () => {
    const { token } = useParams()
    const showUnitTestTips = useSelector(assignmentSelectors.showUnitTestTips)
    const [updateAssignmentSettings, { isLoading }] = useUpdateAssignmentSettingsMutation()

    const handleChange = async checked => {
        await updateAssignmentSettings({
            token,
            showUnitTestTips: checked,
        })
    }

    return (
        <Space>
            Show Tips
            <Switch
                checked={showUnitTestTips}
                onChange={handleChange}
                loading={isLoading}
                checkedChildren={<BulbOutlined />}
            />
        </Space>
    )
}

export default ShowTipsSwitch 